import { DEFAULT_FORUMS_GROUP_IMG_URL } from 'constants/index';
import { hlvVanillaMigrationIsActive } from 'services/statsig/featureGates';

const { REACT_APP_COMMUNITY_BASE_URL: COMMUNITY_BASE_URL } = process.env;

export const getGroupsLandingUrl = (): string =>
  hlvVanillaMigrationIsActive()
    ? `${COMMUNITY_BASE_URL}/forums/groups`
    : `${COMMUNITY_BASE_URL}/t5/Groups/ct-p/groups`;

export const getGroupViewUrl = (viewHref?: string | null): string =>
  hlvVanillaMigrationIsActive()
    ? viewHref ?? getGroupsLandingUrl()
    : `${COMMUNITY_BASE_URL}${viewHref || '#'}`;

export const getGroupImageUrl = (imageUrl?: string | null): string => {
  const resolvedImageUrl = imageUrl || DEFAULT_FORUMS_GROUP_IMG_URL;

  return hlvVanillaMigrationIsActive()
    ? imageUrl || `${COMMUNITY_BASE_URL}${DEFAULT_FORUMS_GROUP_IMG_URL}`
    : `${COMMUNITY_BASE_URL}${resolvedImageUrl}`;
};
